<template>
  <v-card flat
    :outlined="card"
    class="my-5 pb-3"
    v-if="item.delivery && item.delivery.deliver" :color="card ? null : 'transparent'"
  >
    <v-card-title v-if="title" v-text="title"
      class="primary--text text-center"
      style="display: block; word-break: normal"
      ></v-card-title
    >
    <v-simple-table dense class="transparent">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Locatie</th>
            <th class="text-left">Kosten</th>
            <th class="text-left">Minimaal</th>
            <th class="text-left">Gratis boven</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(region, i) in item.regions" :key="i">
            <td v-if="region.zipcode">{{ region.zipcode }} **</td>
            <td v-else-if="region.city" v-text="region.city"></td>
            <td v-else-if="region.range">< {{ region.range }} km</td>
            
            <td v-else>{{ region.name }}</td>
            <td>{{ region.cost | toCurrency }}</td>
            <td>{{ region.min | toCurrency }}</td>
            <td>{{ region.max | toCurrency }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
      title: {
        type: String,
        default: function () {
          return null
        },
      },
      card: {
        type: Boolean,
        default: function () {
          return false
        },
      },
    
  },
  data: () => ({}),
  computed: {
    item: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {},
  watch: {},
  methods: {
    
  },
}
</script>

